const events = [
    {
        timestamp: '6:10am - 6:23am',
        title: 'Start Point',
        description: 'Total 6 paddlers started the challenge near @RipTides 11561 Long Beach',
        images: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7820.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7822.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7829.JPG'
           ],
        videos: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7819.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7821.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7823.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7830.mp4'
        ]
    },
    {
        timestamp: '8:13am - 8:27am',
        title: 'Long Beach High School',
        description: 'Passing',
        images: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7842.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7843.JPG'
        ],
        videos: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7835.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7914.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7919.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7916.mp4'
            ]
    },
    {
        timestamp: '8:45am - 8:59am',
        title: 'Long Beach Municipal Fishing Pier',
        description: 'Passing',
        images: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7846.JPG'
          ],
        videos: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7845.mp4',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7847.mp4'
            ]
    },
    {
        timestamp: '9:50am - 9:57am ish',
        title: 'West end - Silver Point Beach, Atlantic Beach, NY',
        description: 'The most west end of Long Beach Island',
        images: [

        ],
        videos: []
    },
    {
        timestamp: '10:45am - 11:39am',
        title: 'Endpoint',
        description: 'Final endpoint',
        images: [
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7855.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7861.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7862.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7865.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7867.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7871.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7874.JPG',
            'https://longbeachpaddleimages.s3.amazonaws.com/IMG_7876.JPG'




        ],
        videos: []
    },
    // Add more events as needed
];

export default events;